import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Configurations from "@/pages/Configurations";
import ProcessInvoice from "@/pages/ProcessInvoice";
import BatchProcess from "@/pages/BatchProcess";
import Settings from "@/pages/Settings";
import HouseholdList from "@/pages/HouseholdList";
import HouseholdDashboard from "@/pages/HouseholdDashboard";
import HouseholdAdminOverview from "@/pages/HouseholdAdminOverview";
import SharedDashboard from "@/pages/SharedDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/shared/:shareId/member/:memberId/pending" element={<SharedDashboard />} />
      <Route path="/shared/:shareId/member/:memberId/:month?" element={<SharedDashboard />} />
      <Route path="/shared/:shareId/pending" element={<SharedDashboard />} />
      <Route path="/shared/:shareId/:month?" element={<SharedDashboard />} />
      <Route path="/:shareId/member/:memberId/pending" element={<SharedDashboard />} />
      <Route path="/:shareId/member/:memberId/:month?" element={<SharedDashboard />} />
      <Route path="/:shareId/pending" element={<SharedDashboard />} />
      <Route path="/:shareId/:month?" element={<SharedDashboard />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/households" element={<ProtectedRoute><HouseholdList /></ProtectedRoute>} />
      <Route path="/households/:configId" element={<ProtectedRoute><HouseholdDashboard /></ProtectedRoute>} />
      <Route path="/admin/households" element={<ProtectedRoute><HouseholdAdminOverview /></ProtectedRoute>} />
      <Route path="/configurations" element={<ProtectedRoute><Configurations /></ProtectedRoute>} />
      <Route path="/process" element={<ProtectedRoute><ProcessInvoice /></ProtectedRoute>} />
      <Route path="/batch-process" element={<ProtectedRoute><BatchProcess /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
